/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Init translation for Calls Detail
 *
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.4.0
 * @since 1.4.0
 */

import { ECallsDetailSteps } from '../../../../pages/WizardCallsDetail/callsDetailConstants';
import { ICallsDetailTranslation } from '../../types/wizards/callsDetail';

export const initCallsDetailTranslation: ICallsDetailTranslation = {
    accountTaken: {
        label: '',
        corporate: '',
        personal: '',
    },
    basketCountLabel: '',
    confirmText: '',
    error: {
        codes: {},
        defaultMessage: '',
    },
    formatLabel: '',
    periodLabel: '',
    priceLabel: '',
    reports: {
        compressionPassword: '',
        destEmailForLink: '',
        needCompression: '',
    },
    sendDocumentTitle: '',
    steps: {
        [ECallsDetailSteps.Prepare]: '',
        [ECallsDetailSteps.Final]: '',
    },
    title: '',
};
